import { logger } from '@saaga/shared/utils/logger.util'
import { useCallback, useState } from 'react'
import { toast } from 'sonner'

export interface EmbeddedCheckoutState {
  isOpen: boolean
  clientSecret: string | null
}

export interface UseEmbeddedCheckoutReturn {
  checkoutState: EmbeddedCheckoutState
  openCheckout: (clientSecret: string) => void
  closeCheckout: () => void
  handleCheckoutComplete: () => void
  onCompleteCallback: (() => void) | null
  setOnComplete: (callback: (() => void) | null) => void
}

export const useEmbeddedCheckout = (): UseEmbeddedCheckoutReturn => {
  const [checkoutState, setCheckoutState] = useState<EmbeddedCheckoutState>({
    isOpen: false,
    clientSecret: null,
  })
  const [onCompleteCallback, setOnCompleteCallbackState] = useState<(() => void) | null>(null)

  const openCheckout = useCallback((clientSecret: string) => {
    setCheckoutState({ isOpen: true, clientSecret })
  }, [])

  const closeCheckout = useCallback(() => {
    setCheckoutState({ isOpen: false, clientSecret: null })
    setOnCompleteCallbackState(null)
  }, [])

  const handleCheckoutComplete = useCallback(() => {
    logger.info('Embedded checkout completed')
    toast.success('Payment completed successfully')
    closeCheckout()
    onCompleteCallback?.()
  }, [closeCheckout, onCompleteCallback])

  const setOnComplete = useCallback((callback: (() => void) | null) => {
    setOnCompleteCallbackState(() => callback)
  }, [])

  return {
    checkoutState,
    openCheckout,
    closeCheckout,
    handleCheckoutComplete,
    onCompleteCallback,
    setOnComplete,
  }
}
